import '../../sass/plugins/video_plugin.scss';
import { callOnce } from '../utils/initialize';

$(() => {
  const $videoPlugins = $('.video-plugin--uploaded');

  const initializeUploadedVideoPlayer = (element) => {
    const $element = $(element);
    const videoPlayerElement = $element
      .find('video.video-plugin__player--uploaded')
      .get(0);
    const $videoPlayerModal = $element.find('.video-plugin__modal');

    const playVideo = () => {
      videoPlayerElement.play();
    };

    const stopVideo = () => {
      videoPlayerElement.pause();
      videoPlayerElement.currentTime = 0;
    };

    const onClickOnModal = ($event) => {
      if ($event.target !== videoPlayerElement) {
        $videoPlayerModal.modal('hide');
      }
    };

    $videoPlayerModal.on('show.bs.modal', playVideo);
    $videoPlayerModal.on('hidden.bs.modal', stopVideo);
    $videoPlayerModal.on('click', onClickOnModal);
  };

  const initializeAllUploadedPlayers = () => {
    $videoPlugins.each((_, element) => initializeUploadedVideoPlayer(element));
  };

  callOnce(initializeAllUploadedPlayers);
});
